import { Pipe } from '@angular/core';

@Pipe({ standalone: false, name: 'console' })
export class ConsolePipe {
	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	constructor() {}
	transform(value) {
		console.log(value);
		return '';
	}
}
